{
    "PageTitle": "Rezervare camera de sedinte / spatiu de lucru",
    "location": "Selectati locatia / camera",
    "date": "Data",
    "from_date": "Data de inceput",
    "to_date": "Data de sfarsit",
    "toDateError": "Data de sfarsit trebuie sa fie egala sau ulterioara datei de inceput si intervalul maxim dintre cele doua date este de 30 de zile.",
    "topic": "Subiect",
    "timeFrom": "Ora de inceput",
    "timeUntil": "Ora de sfarsit",
    "startTime": "Ora de inceput",
    "capacity": "Cati oameni vor participa?",
    "btnSubmit": "Trimite",
    "btnReset": "Resetare",
    "formReset": "Resetare formular",
    "errMsg": "Va rugam completati toate campurile!",
    "inputPlaceholder": "input...",
    "hours": "ore",
    "minutes": "minute",
    "starting": "Inceput",
    "duration": "Durata",
    "btnSearch": "Cautare",
    "locationOptionLabel": "Locatie, Nume birou / Număr",
    "startOptionLabel": "Selectati ora de inceput",
    "durationOptionLabel": "Selectati durata",
    "capacityOptionLabel": "Selectati capacitatea",
    "searchText": "Va rugam asteptati, incercam sa ne conectam la server!",
    "dummyLocationValueOne": "Locatie 1",
    "dummyLocationValueTwo": "Locatie 2",
    "roomAvailableTextDummy": "Am gasit 27 spatii disponibile pentru 24 Apr, 1pm - 2pm in cladirea de pe strada Strandului, numarul 119 ",
    "roomAvailableFound": "Gasit",
    "roomAvailableSpaces": "spatii la",
    "roomAvailablein": "in",
    "floorDropdownDummy": " cladire",
    "selectedFloorOptionOneDummy": "EG",
    "selectedFloorOptionTwoDummy": "OG",
    "meetingLocationLabel": "Locatia sedintei",
    "titleOfMeetingLabel": "Titlul sedintei",
    "titleOfMeetingPlaceholder": "Introduceti titlul sau subiectul sedintei planificate",
    "descOfMeetingPlaceholder": "Adaugati descriere",
    "meetingDescriptionLabel": "Descrierea sedintei (optional)",
    "availableLabel": "Disponibil",
    "busyLabel": "Indisponibil",
    "confirmBookingBtn": "Confirmati rezervarea",
    "bookingSuccessLabel": "Rezervarea biroului a fost efectuata cu succes",
    "bookingFailureLabel": "A aparut o problema. Va rugam incercati din nou mai tarziu.",
    "selectRoomLocation": "Selectati locatia / biroul",
    "futureDateError": "Va rugam selectati o data/ora corecta pentru perioada urmatoare.",
    "noSlotAvailable": "Nu sunt disponibile sloturi",
    "tokenRequired": "Token de acces necesar lipseste sau a expirat.",
    "roomBooked": "Biroul este deja rezervat!",
    "roomPartiallyBooked": "Sala de sedinte este partial rezervata!",
    "participantError": "Planificati sa rezervati pentru ",
    "participantErrorMsg": " participanti, insa capacitatea salii este de doar ",
    "partiallyFree": "Partial liber",
    "startingTime": "Ora de inceput",
    "participants": "Numar de participanti",
    "max": "Maxim",
    "capacityLabel": "Capacitate",
    "dashboard": "Afiseaza rezervarile mele",
    "manageBookings": "Gestioneaza rezervarile",
    "bookAgain": "Rezerva din nou",
    "cancelBookingConfrim": "Sunteti sigur ca doriti sa anulati aceasta sedinta",
    "list": "Lista",
    "search": "Cauta",
    "type": "tipul",
    "updateBookingApiSucessMsg": "Rezervarea a fost actualizata cu succes",
    "rebookingApiSucessMsg": "Rezervare efectuata cu succes",
    "cancelBookingApiSucessMsg": "Rezervare anulata cu succes",
    "noUpcomingBooking": "In prezent nu aveti rezervari viitoare",
    "noPastBooking": "In prezent nu aveti rezervari anterioare",
    "apiFailDefaultMsg": "Ceva nu a functionat. Va rugam incercati din nou mai tarziu.",
    "confirm": "Confirmati",
    "cancel": "Anulare",
    "close": "Inchidere",
    "fieldRequired": "Acest camp este obligatoriu",
    "selectLocation": "Va rugam selectati locatia",
    "selectDate": "Va rugam selectati o data pentru rezervare",
    "meetingTitleMissing": "Titlul sedintei lipseste",
    "numberOfParticipantMissing": "Numarul participantilor lipseste",
    "gingcoDisclaimer": "MyHelp assists in an easy room booking experience. For other Gingco services (eg: Catering Services) you can reach out to Gingco.",
    "availability": {
        "text": "Disponibilitate",
        "free": "Da, disponibila",
        "busy": "Ne pare rau, nu este disponibila",
        "busyHint": "Incercati sa modificati data sau ora, de asemenea puteti verifica birourile din apropiere",
        "partialFree": "Sala de sedinte partial libera",
        "unknown": "Necunoscut"
    },
    "manageBooking": {
        "meetingLocation": "Locatia sedintei",
        "reschedule": "Reprogramare",
        "bookAgain": "Rezervati din nou",
        "rescheduleTo": "Reprogramare la",
        "cancelMeeting": "Anulare sedinta",
        "searchPlaceholder": "Cautati dupa ID-ul sedintei, Descriere, Locatie"
    },
    "durationOptions": {
        "15 Min": "15 Minute",
        "30 Min": "30 Minute",
        "45 Min": "45 Minute",
        "1 Hr": "1 Ora",
        "2 Hr": "2 Ore",
        "4 Hr": "4 Ore",
        "8 Hr": "8 Ore"
    },
    "meetingRoomTypes": {
        "All": "Toate",
        "Hot Desk": "Birou de lucru",
        "Meeting Room": "Sala de sedinte"
    },
    "peopleCount": "Câte persoane participă?"
}